<template>
  <div class="guided-search">
    <div v-if="!displayStepperModal && !displayReassuranceStep" class="guided-search-content">
      <form-component />
    </div>
    <div v-if="displayReassuranceStep && isMounted" class="guided-search-content">
      <reassurance @next-step="nextStep()" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import FormComponent from './Form.vue';
import Reassurance from './steps/Reassurance.vue';
import guidedSearchMixin from './guidedSearchMixin';

export default {
  name: 'App',
  components: {
    FormComponent,
    Reassurance,
  },
  mixins: [ guidedSearchMixin ],
  data() {
    return {
      displayReassuranceStep: true,
      isMounted: false,
    };
  },
  mounted() {
    this.setUserData();
    this.isMounted = true;

    // If google tag manager is deactivated, dataLayer always exist
    // @see https://bureaux-a-partager.atlassian.net/browse/MATCH-8158
    if (window.dataLayer === undefined) {
      window.dataLayer = [];
    }
  },
  methods: {
    ...mapActions({
      setUserData: 'formGuidedSearch/SET_USER_DATA',
    }),
    nextStep() {
      this.displayReassuranceStep = false;
    },
  },
};
</script>
